import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KnowledgeBaseService, KBArticleSummary, KBCategory } from '../../services/knowledge-base.service';

@Component({
  selector: 'app-kb-article-list',
  templateUrl: './kb-article-list.component.html',
  styleUrls: ['./kb-article-list.component.css']
})
export class KbArticleListComponent implements OnInit {
  articles: KBArticleSummary[] = [];
  category: KBCategory = null;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private kb: KnowledgeBaseService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.loading = true;
      this.kb.getCategories().subscribe(cats => {
        this.category = cats.find(c => c.slug === params['categorySlug']);
        if (this.category) {
          this.kb.getArticlesByCategory(this.category.id).subscribe(articles => {
            this.articles = articles;
            this.loading = false;
          });
        }
      });
    });
  }
}
